
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"
import vSelect from "vue-select"
import { Field, FieldSelected, Rule, Trigger } from "@/types"
import { Operator, operatorLabels, operatorsByFieldType } from "@/types/insights/operators"
import api from "@/services/api"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class FieldDropDown extends Vue {
    @Prop({ type: Boolean, default: false })
    private filterByOperatorType!: boolean;

	@Prop({ default: null })
	private field!: Field;

    @setup.State fields!: Field[];

	@setup.Getter("getFieldTypesById") fieldTypesById!: { [key: string]: any };

	@Emit()
	private selected (field: any) {
		const dataTypeName = this.getFieldDataTypeName(field)
		const primitiveDataType = this.fieldTypesById[dataTypeName].type

		const fieldSelected: FieldSelected = {
			field: field,
			primitiveDataType: primitiveDataType,
			dataTypeName: dataTypeName
		}

		return fieldSelected
	}

	private getFieldDataTypeName (fieldId: string): string {
		const foundField = this.getField(fieldId)
		if (foundField && foundField.dataType) {
			return foundField.dataType
		}

		return ""
	}

	private getField (fieldId: string): Field | null {
		let foundField = this.fields.find(f => f.id === fieldId)
		if (foundField) {
			return foundField
		}

		return null
	}
}
